import { render } from "./DoctorOrderStudentDetail.vue?vue&type=template&id=18e507d7"
import script from "./DoctorOrderStudentDetail.vue?vue&type=script&lang=js"
export * from "./DoctorOrderStudentDetail.vue?vue&type=script&lang=js"

import "./DoctorOrderStudentDetail.vue?vue&type=style&index=0&id=18e507d7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__